/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, change } from "redux-form";
import actionCreators from "../../../../../store/OfficeHours/Reports/actionCreators";
import appointmentsActionCreators from "../../../../../store/OfficeHours/Appointments/actionCreators";
import { RenderSelectField, RenderDatepicker } from "../../../../../common/components/FormFields";
import { withStyles, Button } from "@material-ui/core";
import formsCss from "../../../../../common/styles/forms.css";
import globalsCss from "../../../../../common/styles/globals.css";
import { processSchoolYears } from "../../helpers/schoolYear";
import { validateRequiredFields } from "../../../../../common/services/formHelpers";

class GlobalStudentBookingHistoryForm extends Component {
    componentDidMount() {
        const { schoolYears, gettOfficeHoursSchoolYearsAndTerms, clearErrorResponse } = this.props;

        clearErrorResponse();

        if (schoolYears === null) {
            gettOfficeHoursSchoolYearsAndTerms();
        }

        this.props.initialize(this.props.initialValues);
    }

    clearSchoolYearSelect = () => {
        this.props.updateForm("schoolyear", null);
    };

    handleChangeSchoolYear = (e, value) => {
        const dates = value.split("#");
        this.props.updateForm("from", dates[0]);
        this.props.updateForm("to", dates[1]);
    };

    onSubmit = values => {
        this.props.createGlobalStudentBookingHistoryReport({ ...values });
    };

    render() {
        const {
            handleSubmit,
            schoolYears,
            errorRes: { error, errors },
        } = this.props;

        if (schoolYears === null) return null;

        return (
            <form onSubmit={handleSubmit(this.onSubmit)}>
                <div css={globalsCss.helpers.mt20}>
                    <h4>Time period</h4>
                </div>
                <div className="row">
                    <div className="col-sm-4 col-xs-12">
                        <div css={formsCss.labelBig}>Select year, term ... </div>
                        <Field
                            name="schoolyear"
                            component={RenderSelectField}
                            label="Select value"
                            errorRes={errors.schoolyear}
                            options={processSchoolYears(schoolYears)}
                            onChange={this.handleChangeSchoolYear}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div css={formsCss.labelBig}>...or time period</div>
                    </div>
                    <div className="col-sm-4 col-xs-12">
                        <Field
                            name="from"
                            errorRes={errors.from}
                            component={RenderDatepicker}
                            format={null}
                            hintText="Enter Date"
                            fullWidth
                            css={formsCss.field}
                            onChange={this.clearSchoolYearSelect}
                        />
                    </div>
                    <div className="col-sm-4 col-xs-12">
                        <Field
                            name="to"
                            errorRes={errors.to}
                            component={RenderDatepicker}
                            format={null}
                            hintText="Enter Date"
                            fullWidth
                            css={formsCss.field}
                        />
                    </div>
                </div>
                {error && (
                    <div css={[formsCss.genericError, formsCss.genericErrorMarginTop]}>{error}</div>
                )}
                <div css={formsCss.actions}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        css={formsCss.btnSubmit}
                    >
                        Generate report
                    </Button>
                </div>
            </form>
        );
    }
}

const FORM_NAME = "GlobalStudentBookingHistory";

const validate = values => {
    const requiredFields = {
        from: "Required",
        to: "Required",
    };

    if (!!values.from && !!values.to && values.from > values.to)
        return { to: "End date must be greater than start date" };

    return validateRequiredFields(requiredFields, values);
};

const form = reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    validate,
})(withStyles(formsCss)(GlobalStudentBookingHistoryForm));

const mapStateToProps = ({
    OfficeHoursReport: { errorRes },
    OfficeHoursAppointments: { schoolYears },
}) => {
    return {
        schoolYears,
        errorRes,
    };
};

const dispatchToProps = {
    updateForm: (key, newValue) => change(FORM_NAME, key, newValue),
    gettOfficeHoursSchoolYearsAndTerms:
        appointmentsActionCreators.gettOfficeHoursSchoolYearsAndTerms.create,
    createGlobalStudentBookingHistoryReport:
        actionCreators.createGlobalStudentBookingHistoryReport.create,
    clearErrorResponse: actionCreators.clearErrorResponse.create,
};

export default connect(mapStateToProps, dispatchToProps)(form);
